import type { Meta, StoryObj } from "@storybook/react";

import { ReplayAnimationDecorator } from "@/__stories__/ReplayAnimationDecorator";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import type { PopInViewProps } from "@/ui/layout/animated/PopInView";
import { PopInView } from "@/ui/layout/animated/PopInView";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<PopInViewProps> = {
  title: "Layout/Animated/Pop In View",
  component: PopInView,
  argTypes: {
    delay: {
      control: { max: 3000, min: 0, step: 100, type: "number" },
    },
  },
  args: {
    delay: 0,
  },
};

type Story = StoryObj<PopInViewProps>;

const Default: Story = {
  render: (args) => {
    return (
      <ReplayAnimationDecorator>
        <PopInView delay={args.delay}>
          <Box
            alignItems="center"
            backgroundColor={ColorToken.Primary10}
            borderRadius={12}
            justifyContent="center"
            padding={40}
          >
            <Text testID="story-text" variant="body">
              Pops in with overshoot
            </Text>
          </Box>
        </PopInView>
      </ReplayAnimationDecorator>
    );
  },
};

const WithDelay: Story = {
  render: () => {
    const cadence = 380;
    const labels = ["Top left", "Top right", "Bottom right", "Bottom left"];
    return (
      <ReplayAnimationDecorator>
        {/* eslint-disable-next-line max-params -- map callback requires index for delay */}
        {labels.map((label, index) => (
          <PopInView delay={index * cadence} key={label}>
            <Box
              backgroundColor={ColorToken.Primary10}
              borderRadius={12}
              padding={16}
            >
              <Text testID={`story-${index}`} variant="body">
                {label} (delay: {index * cadence}ms)
              </Text>
            </Box>
          </PopInView>
        ))}
      </ReplayAnimationDecorator>
    );
  },
};

export { Default, WithDelay };
export default StoryMeta;
